import { HttpClient } from '@angular/common/http';
import { TransferState } from '@angular/core';
import { TranslateLoader, type TranslationObject } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { Language } from '@api/models';
import { makeLangStateKey } from '../../helpers/make-lang-state-key.function';

export class TranslateLoaderBrowser implements TranslateLoader {
  private path = '/assets/translations/';

  constructor(private http: HttpClient, private transferState: TransferState) {
  }

  public getTranslation(lang: Language): Observable<TranslationObject> {
    const translation = this.transferState.get(makeLangStateKey(lang), null);

    if (translation) {
      return of(translation);
    } else {
      return this.http.get<TranslationObject>(`${this.path}${lang}.json`);
    }
  }
}
